export const CHARGED_FEES_INVOICE_SCOPE = 'charged-fees-invoice-email';

export enum CHARGED_FEES_INVOICE_EMAIL {
    SUBJECT = 'SUBJECT',
    CUSTOM_MESSAGE = 'CUSTOM_MESSAGE'
}